module.exports = __webpack_public_path__ + "img/GD11X5.png";